import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ItemAttributeChildLinkListingContainerModel } from '../../../../../../models/aggregates/erp/attribute/index';
import { ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ItemAttributeChildLinkListingService extends BaseApiTemplateService<any> {
  // https://api-test.akaun.com/core2/tnt/dm/erp/fi/fi-items/child-link-attribute-sets
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/child-link-attribute-sets/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/child-link-attribute-sets';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/child-link-attribute-sets';
    this.httpClient = http;
  }

  public attributeBackoffice(
    item_hdr_guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + Core2Config.BACKOFFICE_EP_SUFFIX + '?fi_item_hdr_guid=' + item_hdr_guid;
    }
    const url = this.apiUrl ;
    return this.httpClient.get<BasicApiResponseModel<any>>(
      url,
      this.getHttpHeaderJson(visa)
    );
  }

  attributeBackofficeEp(item_hdr_guid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/${Core2Config.BACKOFFICE_EP_SUFFIX}?fi_item_hdr_guid=${item_hdr_guid}`;
    }
    const UrlByCriteria = this.apiUrl;
    let dtoObject = {};
    return this.httpClient.get<BasicApiResponseModel<any>>(UrlByCriteria, this.getHttpHeaderJson(visa));
  }

}
